import { useEffect, useRef, useState } from "react"
import { FiltersContext } from "../filters/filtersProvider"
import { useFirestoreQuery } from "../firebase/firebase"
import { QuestionList } from "../item/QuestionList"
import { TopBar } from "../bar/topbar"
import { FilterMenu } from "../filters/filterMenu"
import { SelectedMenu } from "../selected/selectedMenu"
import { SettingsMenu } from "../settings/settingsMenu"
import { LocationContext } from "../nav/pageChooser"
import { BelowBar } from "../bar/belowBar"
import { Box, Theme, useTheme } from "@mui/material"
import { NavMenu } from "../nav/navMenu"
import { useIsMobile } from "../device/useIsMobile"
import { SelectedItemsContext } from "../selected/selectedItemsProvider"
import { IQuestion } from "../types"
import { useContextWithGuard } from "../helpers/useContextWithGuard"
import { SelectAllRemoveAll } from "../selected/selectAllRemoveAll"
import { ToggleSearchAlbumButton } from "../nav/toggleSearchAlbumButton"
import { ShareButton } from "../nav/shareButton"
import { ScrollIntoViewEffect } from "./scrollIntoView"
import { Logo } from "../theme/logo"
import { TiledBackground } from "../theme/background"


export const SearchPage = () => {
    const theme = useTheme<Theme>();
    const [cursor, setCursor] = useState<IQuestion | null>(null)
    const { filters } = useContextWithGuard(FiltersContext, "FiltersContext");
    const { collection, topic, subTopic, subSubTopic } = useContextWithGuard(LocationContext, "LocationContext");
    const { selectedQns } = useContextWithGuard(SelectedItemsContext, "SelectedItemsContext");

    const isMobile = useIsMobile();

    const { data, loading, error } = useFirestoreQuery({
        topic, subTopic, subSubTopic,
        filters,
        collectionName: collection,
        cursor,
    });

    const topbarRef = useRef<HTMLDivElement>(null);
    const [topbarHeight, setTopbarHeight] = useState(0);

    useEffect(() => {
        if (topbarRef.current) {
            const measuredHeight = topbarRef.current.offsetHeight;
            setTopbarHeight(measuredHeight);
        }
    }, []);

    return (
        isMobile
            ?
            <>
                <TopBar ref={topbarRef} >
                    {selectedQns.length === 0 ?
                        <>
                            <SettingsMenu />
                            <FilterMenu setCursor={setCursor} />
                            <SelectAllRemoveAll visibleQns={data} />
                            <ToggleSearchAlbumButton />
                        </>
                        :
                        <>
                            <SelectedMenu />
                            <SelectAllRemoveAll visibleQns={data} />
                        </>
                    }
                    <Box flexGrow={1} />
                    <ShareButton />
                    <Logo />
                </TopBar>
                <div style={{
                    marginTop: topbarHeight,
                    position: "relative",
                    minHeight: "100vh",
                    background: theme.bee.contentBackground,
                }}>
                    <BelowBar topbarHeight={topbarHeight} >
                        <NavMenu setCursor={setCursor} />
                    </BelowBar>
                    <QuestionList data={data} />
                    <ScrollIntoViewEffect setCursor={setCursor} data={data} />
                </div>
            </>
            :
            <>
                <TopBar ref={topbarRef} >
                    {selectedQns.length === 0 ?
                        <>
                            <SettingsMenu />
                            <FilterMenu setCursor={setCursor} />
                            <SelectAllRemoveAll visibleQns={data} />
                            <ToggleSearchAlbumButton />
                            <NavMenu setCursor={setCursor} />
                        </>
                        :
                        <>
                            <SelectedMenu />
                            <SelectAllRemoveAll visibleQns={data} />
                        </>
                    }
                    <Box flexGrow={1} />
                    <ShareButton />
                    <Logo />
                </TopBar>
                <div style={{
                    marginTop: topbarHeight,
                    position: "relative",
                    minHeight: "100vh",
                    background: theme.bee.contentBackground,
                }}>
                    <TiledBackground offset={topbarHeight} />
                    <QuestionList data={data} />
                    <ScrollIntoViewEffect setCursor={setCursor} data={data} />
                </div>
            </>
    )
}